import PaginatedResponse from '../../base/paginatedResponse'
import { ObjectType } from '@nestjs/graphql'
import { MessageThreadDto } from './model.dto'

@ObjectType()
export class MessageThreadPagedResultDto extends PaginatedResponse(MessageThreadDto) {
}
